module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAErCAYAAAAId3mkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAABzSURBVGhD7cqhAYAwAMCwjec5h6OmuQEMInIG15iazrXWMzbN+7y25+PrlmY1q1nNalazmtWsZjWrWc1qVrOa1axmNatZzWpWs5rVrGY1q1nNalazmtWsZjWrWc1qVrOa1axmNatZzWpWs5rVrGb9NY/xArArCR8nqIkGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/error.1.png
// module id = 2134
// module chunks = 1